// extracted by mini-css-extract-plugin
module.exports = {"maincontainer":"MyPrograms_maincontainer__3Y-ED"};